import { getCharterBySlug } from './charterData';
import CharterDetailTemplate from './CharterDetailTemplate';

const CatalinaPage = () => {
  const data = getCharterBySlug('catalina');
  if (!data) return null;
  return <CharterDetailTemplate destination={data} />;
};

export default CatalinaPage;
